'use client';

import { FC, ReactNode } from 'react';

import { ElementProps, Node } from '@ravago/shared/page-data/models/base';
import { NormalizedCaseStudy } from '@ravago/shared/page-data/models/contentful-mapped';
import { Alert } from '@ravago/shared/radiance/components/alert/components/Alert/Alert';
import { useTranslations } from '@ravago/shared/translations/client';

import { ItemInformationTable } from '../../shared/item-information-table/item-information-table';

export const CaseStudyInformationElement: FC<ElementProps<Node>> = ({ globals }) => {
   const { contentEntity, isConsumer } = globals;

   const translate = useTranslations();
   const caseStudy = contentEntity as NormalizedCaseStudy;

   if (!caseStudy) {
      if (isConsumer) return null;

      return <Alert variant="info">No case study selected.</Alert>;
   }

   const properties: { [key: string]: { label: string; value?: ReactNode; dataCy?: string } } = {
      type: {
         label: translate('case-study-detail-info-table-type'),
         value: caseStudy.type,
         dataCy: 'productionCountry'
      },
      productionCountry: {
         label: translate('case-study-detail-header-country'),
         value: caseStudy.productionCountry?.name,
         dataCy: 'productionCountry'
      }
   };

   return <ItemInformationTable properties={properties} primaryColour stroked />;
};
